module.exports = __webpack_public_path__ + "img/service-finance.b15d671.png";